// Connect7 Admin Dashboard — navigation tree
// Each section maps to a sidebar group. Items either point to a dedicated page
// (component-based) or to a generic resource page (kind-based).
import {
  LayoutDashboard, Users as UsersIcon, UsersRound, Sparkles,
  Phone as PhoneI, PhoneIncoming, PhoneOutgoing, Mic, MessagesSquare,
  Globe, Hash, Workflow, ListTree, Volume2, FileAudio, Music,
  Rocket, FileSpreadsheet, Gavel, Megaphone,
  MessageCircle, AtSign,
  Sliders, Layout as LayoutI, Brain, Languages, Library, FileText,
  ClipboardCheck, GraduationCap, Scale, BarChart3, CalendarDays, Trophy, Activity,
  Webhook, KeyRound, Network, Building2, Tag, Timer, DollarSign,
  Lock, FileLock2, ScrollText, ShieldCheck, Palette, Clock,
  Bot, Ban, Gauge, Plug, Ticket, CreditCard, RadioTower, UserCog, MonitorPlay, Signal, Route,
} from "lucide-react";

export const ADMIN_NAV = [
  {
    label: "Overview",
    items: [
      { to: "/admin",           label: "Dashboard",           icon: LayoutDashboard, end: true },
      { to: "/admin/live-dashboard", label: "Live Dashboard",  icon: RadioTower },
      { to: "/admin/orchestration-live", label: "Orchestration Live", icon: Activity },
      { to: "/admin/audit-log", label: "Audit Log",           icon: ScrollText },
    ],
  },
  {
    label: "Organization",
    items: [
      { to: "/admin/users",         label: "Users",                 icon: UsersIcon },
      { to: "/admin/groups",        label: "User Groups",           icon: UsersRound },
      { to: "/admin/skills",        label: "Skills",                icon: Sparkles, kind: "skills" },
      { to: "/admin/working-hours-profiles", label: "Working Hours Profiles", icon: Clock, kind: "working_hours_profiles" },
      { to: "/admin/working-hours", label: "Tenant Hours / Holidays", icon: Clock },
    ],
  },
  {
    label: "Voice / Telephony",
    items: [
      { to: "/admin/sip-trunks",      label: "SIP Trunks",       icon: PhoneI,         kind: "sip_trunks" },
      { to: "/admin/dids",            label: "Inbound DIDs",     icon: PhoneIncoming },
      { to: "/admin/wa-calling",      label: "WhatsApp Calling", icon: MessageCircle },
      { to: "/admin/extensions-range",label: "Extensions Range", icon: Hash },
      { to: "/admin/recording-rules", label: "Recording Rules",  icon: FileAudio,      kind: "recording_rules" },
      { to: "/admin/caller-id-pool",  label: "Caller-ID Pool",   icon: PhoneOutgoing,  kind: "caller_id_pool" },
      { to: "/admin/music-on-hold",   label: "Music on Hold",    icon: Music,          kind: "music_on_hold" },
      { to: "/admin/audio-prompts",   label: "Audio Prompts",    icon: Volume2,        kind: "audio_prompts" },
      { to: "/admin/amd-settings",    label: "AMD Settings",     icon: Bot },
      { to: "/admin/telephony",       label: "Telephony Engine", icon: Activity },
    ],
  },
  {
    label: "Routing / ACD",
    items: [
      { to: "/admin/queues",        label: "Inbound Queues",   icon: ListTree, kind: "queues" },
      { to: "/admin/ivr-flows",     label: "IVR Flows",        icon: Workflow, kind: "ivr_flows" },
      { to: "/admin/time-conditions", label: "Time Conditions", icon: Clock,   kind: "time_conditions" },
      { to: "/admin/vip-rules",     label: "VIP / Priority",   icon: Trophy,   kind: "vip_rules" },
      { to: "/admin/voicemail",     label: "Voicemail Boxes",  icon: Mic,      kind: "voicemail_boxes" },
      { to: "/admin/did-routes",    label: "DID Routing",      icon: Activity, kind: "did_routes" },
    ],
  },
  {
    label: "Outbound / Campaigns",
    items: [
      { to: "/admin/campaigns",         label: "Campaigns",       icon: Rocket },
      { to: "/admin/dialer",            label: "Predictive Dialer", icon: Gauge },
      { to: "/admin/lead-lists",        label: "Lead Lists",      icon: FileSpreadsheet },
      { to: "/admin/dnc-lists",         label: "DNC Lists",       icon: Ban },
      { to: "/admin/compliance-rules",  label: "Compliance",      icon: Gavel,          kind: "compliance_rules" },
      { to: "/admin/voice-broadcast",   label: "Voice Broadcast", icon: Megaphone },
    ],
  },
  {
    label: "Omnichannel",
    items: [
      { to: "/admin/channels",          label: "Channels Hub",      icon: MessagesSquare },
      { to: "/admin/webchat",           label: "Webchat Widgets",   icon: Globe,        kind: "webchat_widgets" },
      { to: "/admin/wa-templates",      label: "WhatsApp Templates",icon: MessageCircle,kind: "wa_templates" },
      { to: "/admin/email-signatures",  label: "Email Signatures",  icon: AtSign,       kind: "email_signatures" },
      { to: "/admin/canned-responses",  label: "Canned Responses",  icon: FileText,     kind: "canned_responses" },
    ],
  },
  {
    label: "Catalogs",
    items: [
      { to: "/admin/dispositions",  label: "Dispositions",  icon: Tag,  catalog: "dispositions" },
      { to: "/admin/pause-codes",   label: "Pause Codes",   icon: Timer,catalog: "pause-codes" },
      { to: "/admin/wrapup-codes",  label: "Wrap-up Codes", icon: ClipboardCheck, catalog: "wrapup-codes" },
      { to: "/admin/crm-screens", label: "CRM Screens", icon: ListTree },
    ],
  },
  {
    label: "Agent UI",
    items: [
      { to: "/admin/agent-ui",      label: "Feature Toggles", icon: Sliders },
      { to: "/admin/agent-layouts", label: "Screen Layouts",  icon: LayoutI, kind: "agent_layouts", requireRole: "super_super_admin" },
    ],
  },
  {
    label: "AI / Speech",
    items: [
      { to: "/admin/ai-suite",     label: "AI Suite",          icon: Sparkles },
      { to: "/admin/orchestration",      label: "AI Orchestration",   icon: Bot },
      { to: "/admin/llm-config",   label: "LLM Configuration", icon: Brain,    kind: "llm_configs", requireRole: "super_super_admin" },
      { to: "/admin/stt-config",   label: "STT Configuration", icon: Languages,kind: "stt_configs", requireRole: "super_super_admin" },
      { to: "/admin/kb",           label: "Knowledge Base",    icon: Library,  kind: "kb_documents" },
      { to: "/admin/ai-prompts",   label: "AI Prompts",        icon: FileText, kind: "ai_prompts", requireRole: "super_super_admin" },
      { to: "/admin/pii-rules",    label: "PII Redaction",     icon: FileLock2,kind: "pii_rules", requireRole: "super_super_admin" },
    ],
  },
  {
    label: "Quality Management",
    items: [
      { to: "/admin/qm/console",   label: "QM Console",     icon: Sparkles },
      { to: "/admin/screen-recording", label: "Screen Recording", icon: MonitorPlay },
      { to: "/admin/scorecards",   label: "Scorecards",     icon: ClipboardCheck, kind: "scorecards" },
      { to: "/admin/qm-samples",   label: "Sampling Rules", icon: Activity,       kind: "qm_samples", requireRole: "super_super_admin" },
      { to: "/admin/coaching",     label: "Coaching Plans (legacy)", icon: GraduationCap,  kind: "coaching_plans", requireRole: "super_super_admin" },
      { to: "/admin/calibration",  label: "Calibration (legacy)",    icon: Scale,  kind: "qm_calibrations", requireRole: "super_super_admin" },
    ],
  },
  {
    label: "Reporting / BI",
    items: [
      { to: "/admin/reports/dashboard", label: "KPI Dashboard",     icon: Activity },
      { to: "/admin/reports/standard",  label: "Standard Reports",  icon: BarChart3 },
      { to: "/admin/reports/agent-performance", label: "Agent Performance", icon: UserCog },
      { to: "/admin/reports/call-detail", label: "Detailed Lead Report", icon: FileText },
      { to: "/admin/reports/traffic", label: "Inbound / Outbound", icon: PhoneIncoming },
      { to: "/admin/reports/omnichannel", label: "Omnichannel Reports", icon: Route },
      { to: "/admin/reports/custom",    label: "Custom Builder",    icon: Sliders },
      { to: "/admin/reports/leaderboards", label: "Leaderboards",   icon: Trophy },
      { to: "/admin/reports/broadcast",  label: "Voice Broadcast Report", icon: Megaphone },
      { to: "/admin/report-templates",  label: "Report Templates",  icon: FileText,    kind: "report_templates" },
      { to: "/admin/report-schedules",  label: "Scheduled Reports", icon: CalendarDays,kind: "report_schedules" },
    ],
  },
  {
    label: "Integrations & API",
    requireRole: "super_super_admin",
    items: [
      { to: "/admin/integrations",      label: "Integrations Vault", icon: KeyRound },
      { to: "/admin/integrations-hub",  label: "CRM & Open API Hub", icon: Plug },
      { to: "/admin/webhooks",      label: "Webhooks",           icon: Webhook,  kind: "webhooks" },
      { to: "/admin/api-keys",      label: "API Keys",           icon: KeyRound, kind: "api_keys" },
      { to: "/admin/crm-mappings",  label: "CRM Field Maps",     icon: Network,  kind: "crm_mappings" },
    ],
  },
  {
    label: "Ticketing",
    requireRole: "super_super_admin",
    items: [
      { to: "/admin/integrations-hub?tab=tickets",  label: "Tickets Inbox",     icon: Ticket },
      { to: "/admin/ticket-queues",     label: "Ticket Queues",     icon: ListTree, kind: "ticket_queues" },
      { to: "/admin/ticket-categories", label: "Ticket Categories", icon: Tag,      kind: "ticket_categories" },
      { to: "/admin/sla-policies",      label: "SLA Policies",      icon: Timer,    kind: "sla_policies" },
    ],
  },
  {
    label: "Branding & White-Label",
    requireRole: "super_super_admin",
    items: [
      { to: "/admin/branding", label: "Branding", icon: Palette },
    ],
  },
  {
    label: "Security & Compliance",
    requireRole: "super_super_admin",
    items: [
      { to: "/admin/retention",       label: "Retention Policies", icon: FileLock2, kind: "retention_policies" },
      { to: "/admin/ip-allowlist",    label: "IP Allowlist",       icon: Lock,      kind: "ip_allowlists" },
      { to: "/admin/consent",         label: "Consent Templates",  icon: ShieldCheck, kind: "consent_templates" },
    ],
  },
  // Tenants section is filtered to super_super_admin only at render time
  {
    label: "Billing & Plans",
    requireRole: "super_super_admin",
    items: [
      { to: "/admin/billing", label: "Billing & Usage", icon: CreditCard },
    ],
  },
  {
    label: "Operator",
    requireRole: "super_super_admin",
    items: [
      { to: "/admin/tenants",       label: "Tenants",     icon: Building2 },
      { to: "/admin/access-control",label: "Access Control", icon: UserCog },
      { to: "/admin/rate-plans",    label: "Rate Plans",  icon: DollarSign, kind: "rate_plans" },
    ],
  },
];

// Top-level "Domain" grouping — collapses 17 sections into 5 calm pillars.
// Each domain references section labels from ADMIN_NAV above.
export const ADMIN_DOMAINS = [
  { key: "workspace",     label: "Workspace",        icon: LayoutDashboard, sections: ["Overview"] },
  { key: "operations",    label: "Operations",       icon: PhoneI,          sections: ["Voice / Telephony", "Omnichannel", "Routing / ACD", "Outbound / Campaigns"] },
  { key: "intelligence",  label: "Intelligence & QM", icon: Brain,          sections: ["AI / Speech", "Quality Management", "Reporting / BI"] },
  { key: "configuration", label: "Configuration",    icon: Sliders,         sections: ["Catalogs", "Agent UI", "Integrations & API", "Ticketing"] },
  { key: "administration",label: "Administration",   icon: ShieldCheck,     sections: ["Organization", "Security & Compliance", "Billing & Plans", "Branding & White-Label", "Operator"] },
];

// Given already role/search-filtered sections, group them under domains.
export function buildDomains(sections) {
  const byLabel = Object.fromEntries(sections.map((s) => [s.label, s]));
  return ADMIN_DOMAINS.map((d) => ({
    ...d,
    sectionList: d.sections.map((l) => byLabel[l]).filter(Boolean),
  })).filter((d) => d.sectionList.length > 0);
}

// Flat lookup for kind -> nav item (used by the generic resource page header)
export function findNavItemByKind(kind) {
  for (const sec of ADMIN_NAV) {
    for (const it of sec.items) {
      if (it.kind === kind) return { ...it, sectionLabel: sec.label };
    }
  }
  return null;
}
